import { useNavigate } from 'react-router-dom'
import classes from './PlayListItem.module.css'

const PlaylistItemWithNoData = (props) => {
  const navigate = useNavigate();
  const { playlistId, marginRight, marginLeft, title, seeAll} = props
    

  return (
    <div
      className={`${classes.min} col-sm-6 col-md-4 col-lg-3 col-12 col-xl-2 ${classes.list_item}`}
      style={{
        marginRight: `${marginRight}px`,
        marginLeft: `${marginLeft}px`,
        cursor: "pointer"
      }}
      onClick={() => navigate(`/single-playlist/${playlistId}`)}
    >
      <div
        style={{ backgroundImage: `url(../assets/video/noVideo.jpeg)` }}
        className={`${classes.main_div} d-flex align-items-end ${classes.no_video} overflow-hidden position-relative`}
      />
      <h4 className={`${classes.playlist_title} mb-0`}>{title}</h4>
      <h5 className={`${classes.color_black} ${classes.font_size_14}`}>
        {seeAll}
      </h5>
    </div>
  )
}

export default PlaylistItemWithNoData